
// Release the $ symbol
jQuery.noConflict();

jQuery(document).ready(function ($) {

    jQuery('.search-btn-icon').on('click', function () {
      jQuery('.search__box.collection-toolbar-search').fadeToggle();
    });

    /*===== Header Fixed =======*/

        jQuery(window).on("scroll", function () {
            if ($(this).scrollTop() > 50) {
                jQuery("body").addClass("header-fixed");
            } else {
                jQuery("body").removeClass("header-fixed");
            }
        });
    
     /*===== Recipes-Mobile  =======*/

    jQuery(document).on('click', '.filter-responisve', function () {
        jQuery('body').addClass('filter-open');
    });
    jQuery(document).on('click', '.filter-close', function () {
        jQuery('body').removeClass('filter-open');
    });

    /*===== Home Page transparency matters  =======*/

    var $wrapper = $(".typewriter-wrapper");

    if ($wrapper.length) {

      var $output = $wrapper.find(".typewriter-text");
      var $words = $wrapper.find(".typewriter-data span");

      if ($words.length) {

        var phrases = [];
        $words.each(function () {
          phrases.push($(this).text().trim());
        });

        var phraseIndex = 0;
        var charIndex = 0;
        var isDeleting = false;

        function typeLoop() {

          var current = phrases[phraseIndex];

          if (!isDeleting) {
            $output.text(current.substring(0, charIndex + 1));
            charIndex++;

            if (charIndex === current.length) {
              setTimeout(function () {
                isDeleting = true;
              }, 1200);
            }

          } else {

            $output.text(current.substring(0, charIndex - 1));
            charIndex--;

            if (charIndex === 0) {
              isDeleting = false;
              phraseIndex = (phraseIndex + 1) % phrases.length;
            }
          }

          var speed = isDeleting ? 40 : 80;
          setTimeout(typeLoop, speed);
        }

        typeLoop();
      }
    }

    /*===== Home Page Text Slider  =======*/

    if ($('.image-text-swiper').length) {
        $('.image-text-swiper').each(function () {
            var $this = $(this);
            new Swiper(this, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                allowTouchMove: true,
                speed: 800,
                effect: 'slide',
                autoplay: {
                    delay: 3000,        // 3 seconds
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false
                },
                navigation: {
                    nextEl: $this.find('.image-text-next')[0],
                    prevEl: $this.find('.image-text-prev')[0],
                }
            });
        });
    }

    /*===== Sub Menu =======*/

    // Add class to parent items that have submenu
    $('.menu-drawer__menu.has-submenu > li').each(function () {
        if ($(this).find('.menu-drawer__menu--childlist').length) {
            $(this).addClass('has-child');
        }
    });

    $('.menu-drawer__menu.has-submenu > li.has-child').on('click', function (e) {
      e.stopPropagation();

      var currentItem = $(this);

      // If already open → close it
      if (currentItem.hasClass('submenu-open')) {
          currentItem
              .removeClass('submenu-open')
              .children('.menu-drawer__menu--childlist')
              .slideUp(300);
      } else {
          // Close other open menus
          $('.menu-drawer__menu.has-submenu > li.submenu-open')
              .removeClass('submenu-open')
              .children('.menu-drawer__menu--childlist')
              .slideUp(300);

          // Open current menu
          currentItem
              .addClass('submenu-open')
              .children('.menu-drawer__menu--childlist')
              .slideDown(300);
      }
  });

    const drawer = $('#Details-menu-drawer-container');
    const menuButton = $('.header__icon--menu');

    menuButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!drawer.hasClass('menu-open')) {
            // OPEN DRAWER
            drawer.attr('open', true);
            drawer.addClass('menu-open');
            $('.menu-drawer__menu.has-submenu > li.submenu-open').removeClass('submenu-open').find('.menu-drawer__menu--childlist').slideUp(300);
        }

    });
    // Close menu when page is restored from browser back
    jQuery(window).on('pageshow', function () {
        drawer.removeAttr('open');
        drawer.removeClass('menu-open');

        jQuery('.menu-drawer__menu.has-submenu > li.submenu-open')
            .removeClass('submenu-open')
            .find('.menu-drawer__menu--childlist')
            .hide();
    });

    /*===== recipes-swiper =======*/

    function initRecipeSlider() {
        if ($(window).width() <= 1024) {
            if (!$('.recipes-swiper').hasClass('swiper-initialized')) {
                new Swiper(".recipes-swiper", {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 20
                    },
                    991: {
                        slidesPerView: 3.5,
                        spaceBetween: 20
                    }
                }
                });
            }
        }
    }
    initRecipeSlider();
    $(window).on('resize', function () {
        initRecipeSlider();
    });

    /*===== Popup =======*/
    // OPEN POPUP
    $('.learn-more, .learn-more-here, .info-text a').on('click', function(e){
        e.preventDefault();
        jQuery("body").addClass("popup-open");
        $('#customPopup, #bulk-popup, #termsPopup')
        .css({
            'display':'flex',
            'opacity':'0'
        })
        .animate({
            opacity:1
        },300);
    });

    // CLOSE POPUP
    $('.popup-close, .bulk-popup__close, .terms-popup-close').on('click', function(){
        jQuery("body").removeClass("popup-open");
        $('#customPopup, #bulk-popup, #termsPopup').animate({
        opacity:0
        },300,function(){
        $(this).css('display','none');
        });

    });

});

jQuery(window).bind("load resize scroll", function () {
    const header_group_Height = jQuery(".shopify-section-group-header-group").outerHeight();
    const header_Height = jQuery(".header-section").outerHeight();
    let totalheight;

     if (jQuery("body").hasClass("header-fixed")) {
        totalheight = header_Height - 1;
    } else {
        totalheight = header_Height;
    }
    // console.log(totalheight);
    jQuery('.header-section .header-drawer .menu-drawer').css({ top: totalheight });

}).resize();


/* selected color */

window.addEventListener("load", function () {
  setTimeout(function () {
    document.querySelectorAll('.form-crm-default--select').forEach(function(select){
      function updateColor() {
        if (select.value === "") {select.style.color = "#696969"; // placeholder color
        } else { select.style.color = "#000"; // selected color
        }} updateColor(); select.addEventListener('change', updateColor);});}, 500);
  setTimeout(function () {
    document.querySelectorAll('.field__input').forEach(function(select){
      function updateColor() {
        if (select.value === "") {select.style.color = "#696969"; // placeholder color
        } else { select.style.color = "#000"; // selected color
        }} updateColor(); select.addEventListener('change', updateColor);});}, 500);
});


/*===== search Box =======*/
document.addEventListener("click", function (e) {
    // 🔍 Click magnify icon
    const icon = e.target.closest(".predictive-search__icon");
    if (icon) {
        const form = icon.closest("form");
        const input = form.querySelector(".search-input");
        if (input && input.value.trim() !== "") {
            form.submit();
        }
    }
    // 🧹 Clear button
    const clearBtn = e.target.closest(".predictive-search__reset-button");
    if (clearBtn) {
        const form = clearBtn.closest("form");
        const input = form.querySelector(".search-input");
        if (input) {
            input.value = "";
            input.focus();
        }
    }
    // 👁 View all button
    const viewAllBtn = e.target.closest(".predictive-search__search-button");
    if (viewAllBtn) {
        const form = viewAllBtn.closest("form");
        const input = form.querySelector(".search-input");
        if (input && input.value.trim() !== "") {
            window.location.href = "/search?q=" + encodeURIComponent(input.value);
        }
    }
});

document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.classList.contains("search-input")) {
        e.preventDefault();
        const form = e.target.closest("form");
        if (e.target.value.trim() !== "") {
            form.Submit();
        }
    }
});


/*===== FAQ =======*/

document.addEventListener("DOMContentLoaded", function () {

  const faqItems = document.querySelectorAll(".faq-item");

  // ❗ If no FAQ on page → stop script
  if (!faqItems.length) return;

  faqItems.forEach((item, index) => {

    const question = item.querySelector(".question");
    const answer = item.querySelector(".answercont");

    // ❗ Skip if structure not found
    if (!question || !answer) return;

    // Reset
    answer.style.maxHeight = 0;

    // Open first item
    if (index === 0) {
      item.classList.add("active");

      setTimeout(() => {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }, 100);
    }

    question.addEventListener("click", () => {

      const activeItem = document.querySelector(".faq-item.active");

      // Close previous
      if (activeItem && activeItem !== item) {
        const activeAnswer = activeItem.querySelector(".answercont");

        if (activeAnswer) {
          activeAnswer.style.maxHeight = 0;
        }

        activeItem.classList.remove("active");
      }

      // Toggle current
      item.classList.toggle("active");

      if (item.classList.contains("active")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = 0;
      }

    });

  });

  /* ============= INFINITE SCROLL ================ */

  const items = document.querySelectorAll(".faq-section .faq-item");

  if (!items.length) return; // ❗ prevent errors

  let itemsPerLoad = 5;
  let currentItems = itemsPerLoad;
  let isLoading = false;

  items.forEach(item => item.classList.add("filtered-visible"));

  function showItems() {

    let visibleItems = Array.from(items).filter(item =>
      item.classList.contains("filtered-visible")
    );

    visibleItems.forEach((item, index) => {

      if (index < currentItems) {

        setTimeout(() => {
          item.style.display = "block";
          item.classList.add("show");
        }, index * 100);

      } else {

        item.classList.remove("show");

        setTimeout(() => {
          item.style.display = "none";
        }, 300);

      }

    });

  }

  showItems();

  window.addEventListener("scroll", function () {

    if (isLoading) return;

    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {

      isLoading = true;

      setTimeout(() => {
        currentItems += itemsPerLoad;
        showItems();
        isLoading = false;
      }, 300);

    }

  });

});

/*===== product Deatils Page  =======*/

 document.addEventListener("DOMContentLoaded", function () {

    const tabs = document.querySelectorAll(".tab-btn");
    const panes = document.querySelectorAll(".tab-pane");
    const accordions = document.querySelectorAll(".accordion-header");

    /* Desktop Tabs */
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {

        const target = this.getAttribute("data-tab");

        tabs.forEach(btn => btn.classList.remove("active"));
        panes.forEach(pane => pane.classList.remove("active"));
        accordions.forEach(acc => acc.classList.remove("active"));

        this.classList.add("active");
        document.getElementById(target).classList.add("active");

        document.querySelector(`.accordion-header[data-tab="${target}"]`)?.classList.add("active");
      });
    });



    /* Slide Helpers */
    function slideUp(el, duration = 400) {
      el.style.height = el.scrollHeight + "px";
      el.offsetHeight;

      el.style.transition = `height ${duration}ms ease`;
      el.style.height = 0;

      setTimeout(() => {
        el.style.display = "none";
        el.style.removeProperty("height");
        el.style.removeProperty("transition");
      }, duration);
    }

    function slideDown(el, duration = 400) {
      el.style.removeProperty("display");
      let display = window.getComputedStyle(el).display;
      if (display === "none") display = "block";
      el.style.display = display;

      let height = el.scrollHeight;

      el.style.height = 0;
      el.offsetHeight;

      el.style.transition = `height ${duration}ms ease`;
      el.style.height = height + "px";

      setTimeout(() => {
        el.style.removeProperty("height");
        el.style.removeProperty("transition");
      }, duration);
    }


    /* Mobile Accordion */
    if (window.innerWidth <= 991) {

      // REMOVE any active state on load (mobile only)
      panes.forEach(p => {
        const content = p.querySelector(".mobile-accordion-content");
        const header = p.querySelector(".accordion-header");

        p.classList.remove("active");
        header?.classList.remove("active");

        if (content) {
          content.style.display = "none";
        }
      });

      accordions.forEach(acc => {
        acc.addEventListener("click", function () {

          const pane = this.closest(".tab-pane");
          const content = pane.querySelector(".mobile-accordion-content");

          const isOpen = pane.classList.contains("active");

          // Close all
          panes.forEach(p => {
            const c = p.querySelector(".mobile-accordion-content");
            const h = p.querySelector(".accordion-header");

            if (p.classList.contains("active")) {
              slideUp(c);
              p.classList.remove("active");
              h.classList.remove("active");
            }
          });

          // Open clicked
          if (!isOpen) {
            pane.classList.add("active");
            this.classList.add("active");
            slideDown(content);

            // Smooth scroll
            setTimeout(() => {
              const header = this;

              requestAnimationFrame(() => {
                const yOffset = -100;
                const y = header.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({
                  top: y,
                  behavior: "smooth"
                });
              });

            }, 350);
          }

        });
      });

    }
});


/*===== recipes Deatils Page  =======*/

document.addEventListener("DOMContentLoaded", function () {

  let currentIndex = 0;

const tabs = document.querySelectorAll('.recipe-tab-btn');
const contents = document.querySelectorAll('.recipe-tab-content');
const tabContainer = document.querySelector('.recipe-tabs-nav');

function isMobile() {
  return window.innerWidth <= 767;
}

/* ================= TABS ================= */
  tabs.forEach((btn, index) => {
    btn.addEventListener('click', function () {

      tabs.forEach(b => b.classList.remove('active'));
      contents.forEach(c => {
        c.classList.remove('active', 'slide-left', 'slide-right');
      });

      this.classList.add('active');

      const target = document.getElementById(this.dataset.tab);
      if (!target) return;

      if (index > currentIndex) {
        target.classList.add('slide-left');
      } else {
        target.classList.add('slide-right');
      }

      target.classList.add('active');
      currentIndex = index;

      /* ================= MOBILE SCROLL (FIXED POSITION) ================= */
      if (isMobile() && tabContainer) {

        const containerRect = tabContainer.getBoundingClientRect();
        const tabRect = this.getBoundingClientRect();

        const currentScroll = tabContainer.scrollLeft;

        const tabStart = tabRect.left - containerRect.left + currentScroll;
        const tabEnd = tabStart + tabRect.width;

        const visibleStart = currentScroll;
        const visibleEnd = currentScroll + containerRect.width;

        let newScroll = currentScroll;

        if (tabStart < visibleStart) {
          newScroll = tabStart - 100;
        } else if (tabEnd > visibleEnd) {
          newScroll = tabEnd - containerRect.width + 100;
        }

        tabContainer.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
      }
      /* ================= END ================= */

    });
  });

  /* ================= INGREDIENT CHECKBOX ================= */
  document.querySelectorAll('.ingredient-item input').forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      this.closest('.ingredient-item')?.classList.toggle('checked', this.checked);
    });
  });

  /* ================= VIDEO POPUP ================= */

  const popup = document.getElementById('videoPopup');
  const popupVideo = document.getElementById('popupVideo');
  const popupImage = document.getElementById('popupImage');
  const closeBtn = document.querySelector('.close-popup');

  if (!popup) return;

  // 👉 OPEN POPUP (VIDEO + IMAGE)
  document.addEventListener('click', function (e) {

    // VIDEO CLICK
    const videoCard = e.target.closest('.video-card');
    if (videoCard) {
      const videoSrc = videoCard.dataset.video;
      if (!videoSrc) return;

      const source = popupVideo.querySelector('source');

      // Reset
      popupImage.style.display = "none";
      popupVideo.style.display = "block";

      popupVideo.pause();
      popupVideo.currentTime = 0;

      if (source) source.src = videoSrc;

      popupVideo.load();
      popupVideo.play();

      popup.classList.add('active');

      // ✅ ADD BODY CLASS + DISABLE SCROLL
      document.body.classList.add('popup-open');
      document.body.style.overflow = 'hidden';

      return;
    }

    // IMAGE CLICK
    const image = e.target.closest('.popup-image');
    if (image) {
      const imageSrc = image.dataset.image;
      if (!imageSrc) return;

      // Reset
      popupVideo.pause();
      popupVideo.currentTime = 0;
      popupVideo.style.display = "none";

      const source = popupVideo.querySelector('source');
      if (source) source.src = "";

      popupImage.src = imageSrc;
      popupImage.style.display = "block";

      popup.classList.add('active');

      // ✅ ADD BODY CLASS + DISABLE SCROLL
      document.body.classList.add('popup-open');
      document.body.style.overflow = 'hidden';
    }

  });

  // 👉 CLOSE POPUP
  function closePopup() {
    popup.classList.remove('active');

    // Reset video
    popupVideo.pause();
    popupVideo.currentTime = 0;
    popupVideo.style.display = "none";

    const source = popupVideo.querySelector('source');
    if (source) source.src = "";

    // Reset image
    popupImage.src = "";
    popupImage.style.display = "none";

    // ✅ REMOVE BODY CLASS + ENABLE SCROLL
    document.body.classList.remove('popup-open');
    document.body.style.overflow = '';
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  // Click outside
  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  /* ================= MASONRY ================= */

  function initMasonry() {
    const grid = document.querySelector(".media-grid");
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(".media-item"));

    let columns = window.innerWidth <= 768 ? 2 : 3;

    grid.innerHTML = "";

    let cols = [];

    for (let i = 0; i < columns; i++) {
      let col = document.createElement("div");
      col.classList.add("media-column");
      grid.appendChild(col);
      cols.push(col);
    }

    items.forEach((item, index) => {
      cols[index % columns].appendChild(item);
    });
  }

  window.addEventListener("load", initMasonry);
  // window.addEventListener("resize", initMasonry);

});

/* recipe-products */

function initRecipeSwiper(container = document) {
    const swipers = container.querySelectorAll(".recipe-products .recipe_product_swiper");

  swipers.forEach((swiperEl) => {
    // Destroy previous instance
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 30,
      //slidesOffsetBefore: 50,
      //slidesOffsetAfter: 50,
      navigation: {
        nextEl: swiperEl.closest('.swiper-wrapper-fix').querySelector(".swiper-button-next"),
        prevEl: swiperEl.closest('.swiper-wrapper-fix').querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        0: { slidesPerView: 1.3 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },

      observer: true,
      observeParents: true,
      watchOverflow: true, // ✅ IMPORTANT (enable correct disable logic)
    });

    // 🔥 FIX: force correct state after layout ready
    requestAnimationFrame(() => {
      swiper.update();
      swiper.navigation.update();
    });

    // 🔥 Extra safety (for images)
    setTimeout(() => {
      swiper.update();
      swiper.navigation.update();
    }, 300);
  });
}
// Load
document.addEventListener("DOMContentLoaded", () => {
    initRecipeSwiper();
  });

  // Shopify editor
document.addEventListener("shopify:section:load", (e) => {
    initRecipeSwiper(e.target);
});

/* recipe-slider */

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".recipe-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      0: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  });
});


/* ================= Product Details Read More  ================= */

document.addEventListener("DOMContentLoaded", function () {

  const rte = document.querySelector("rte-formatter");

  if (!rte || rte.querySelector(".read-more-wrapper")) return;

  const wrapper = document.createElement("div");
  const content = document.createElement("div");
  const btn = document.createElement("button");

  wrapper.className = "read-more-wrapper";
  content.className = "read-more-content";
  btn.className = "read-more-btn";

  content.innerHTML = rte.innerHTML;
  rte.innerHTML = "";

  wrapper.appendChild(content);
  wrapper.appendChild(btn);
  rte.appendChild(wrapper);

  btn.textContent = "Read More";

  const collapsedHeight = 70;

  // Initial state
  content.style.height = "auto";
  content.style.overflow = "hidden";

  // ✅ Correct height check after render
  requestAnimationFrame(() => {

    const fullHeight = content.scrollHeight;

    // If content is small, hide button
    if (fullHeight <= collapsedHeight) {
      btn.style.display = "none";
      content.style.height = "auto";
      content.style.overflow = "visible";
      return;
    }

    // If content is long, collapse it
    content.style.height = collapsedHeight + "px";

    btn.addEventListener("click", function () {

      const isOpen = content.classList.contains("active");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
        content.offsetHeight;
        content.style.height = collapsedHeight + "px";

        btn.textContent = "Read More";
        content.classList.remove("active");

      } else {
        content.style.height = content.scrollHeight + "px";

        btn.textContent = "Read Less";
        content.classList.add("active");

        content.addEventListener("transitionend", function handler() {
          content.style.height = "auto";
          content.removeEventListener("transitionend", handler);
        });

      }

    });

  });

});